// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___13bdT","open":"open___18iMz","link":"link___3cZHK","hover":"hover___1Dty7","active":"active___3zxDo","icon":"icon___3I_ZM","label":"label___3SnG8"};